import React from 'react';
import T from 'prop-types';

const EmptyBox = ({ text }) => (
  <div className="prospects-sidebar__empty-box">
    {text}
  </div>
);

EmptyBox.propTypes = {
  text: T.string,
};

export default EmptyBox;
